import { ChevronDown, X } from 'lucide-react';
import { useConfig } from '../hooks';
import { useTranslate, SupportedLanguage } from '../lib/i18n';
import VendorLogo from './VendorLogo';
import LanguageDropdown from './common/LanguageDropdown';

interface EmbeddedModeStatusBarProps {
  isFeedbackOpen: boolean;
  widgetCloseInteraction: () => void;
  widgetHideInteraction: () => void;
}

const EmbeddedModeStatusBar = ({
  isFeedbackOpen,
  widgetCloseInteraction,
  widgetHideInteraction,
}: EmbeddedModeStatusBarProps) => {
  const t = useTranslate();
  const { data: chatbotConfig } = useConfig();

  return (
    <div className="flex justify-between items-center px-3 py-2.5 bg-sidebar text-sidebar-foreground font-sans z-100000 shrink-0 shadow-md">
      <div className="flex items-center gap-2">
        <VendorLogo className="h-6 w-6" usage="header" />
        <span className="text-nowrap">{chatbotConfig?.title ?? t('embeddedMode.statusText')}</span>
      </div>

      <div className="flex items-center">
        {chatbotConfig?.languages && chatbotConfig.languages.length > 1 && (
          <LanguageDropdown
            languages={chatbotConfig.languages as SupportedLanguage[]}
            className="mr-2"
          />
        )}
        {isFeedbackOpen ? (
          <button
            onClick={() => widgetCloseInteraction()}
            className="h-7 px-2 rounded hover:bg-sidebar-accent hover:text-background transition-colors flex items-center justify-center"
          >
            {t('embeddedMode.exitChat')}
          </button>
        ) : (
          <>
            <button
              className="h-7 w-7 rounded hover:bg-sidebar-accent hover:text-background transition-colors flex items-center justify-center"
              onClick={() => widgetHideInteraction()}
              aria-label={t('embeddedMode.minimize')}
            >
              <ChevronDown size={20} />
            </button>
            <button
              onClick={() => widgetCloseInteraction()}
              className="h-7 w-7 ml-2.5 rounded hover:bg-sidebar-accent hover:text-background transition-colors flex items-center justify-center"
              aria-label={t('embeddedMode.close')}
            >
              <X size={20} />
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default EmbeddedModeStatusBar;
